"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _theme = require("../app-shell/theme");
const useSnorreTheme = ({
  themeUrl,
  defaultTextColor,
  globalsFolder
}) => {
  const [appTheme, setAppTheme] = (0, _react.useState)();
  const [theme, setTheme] = (0, _react.useState)();
  const [globals, setGlobals] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    const getTheme = async themeUrl => {
      const pstyle = fetch(`${themeUrl}/styles.json`);
      const pglobal = fetch(`${themeUrl}${globalsFolder ? `/${globalsFolder}` : ''}/globals.css`);
      const [styles, global] = await Promise.all([pstyle, pglobal]);
      const p = await styles.json();
      const g = await global.text();
      setTheme(p);
      setGlobals(g);
    };
    getTheme(themeUrl);
  }, [themeUrl]);
  (0, _react.useEffect)(() => {
    if (!theme) return;
    setAppTheme((0, _theme.initTheme)(theme, defaultTextColor));
  }, [theme, defaultTextColor]);
  return {
    appTheme,
    globals
  };
};
var _default = exports.default = useSnorreTheme;